/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
/**
 * @ignore - internal component.
 */ const ToggleButtonGroupButtonContext = /*#__PURE__*/ React.createContext(undefined);
if ("production" !== 'production') {
    ToggleButtonGroupButtonContext.displayName = 'ToggleButtonGroupButtonContext';
}
var _default = exports.default = ToggleButtonGroupButtonContext;
